window.mcb.forms.block = function (
  formId,
  prefills,
  blockData
) {
  const _logger = window.mcb.utilities.createLogger("forms.block");
  const formElement = document.getElementById(formId);
  const data = blockData;
  const block = this;
  block.conditionReferenceValues = {};
  let element;
  let fieldCount = 0;

  for (let i_c = 0; i_c < data.columns.length; i_c++) {
    data.columns[i_c].fieldRefs = [];
    for (let i_f = 0; i_f < data.columns[i_c].fields.length; i_f++) {
      data.columns[i_c].fieldRefs.push(new window.mcb.forms.field(
        formId,
        prefills,
        data.columns[i_c].fields[i_f]));
    }

    fieldCount += data.columns[i_c].fieldRefs.length;
  }

  const isEmpty = function () {
    return fieldCount === 0 && data.caption === null;
  }

  return _ = {
    columns: data.columns,
    isEmpty: isEmpty,
    render: function (target, enrichFieldFunction) {
      if (isEmpty()) {
        return;
      }

      element = document.createElement('div');
      element.classList.add(window.mcb.forms.constants.blocks.classBase);

      let forciblyMoved = false;
      if (data.condition !== null) {
        const rules = data.condition.rules;
        data.conditionTriggers = rules.map(r => r.reference);
        const actionType = window.mcb.utilities.strings.toKebab(data.condition.actionType);
        for (let rule of rules) {
          element.classList.add(window.mcb.forms.constants.conditionals.dependance + window.mcb.utilities.strings.toKebab(rule.reference));
          element.classList.add(window.mcb.forms.constants.conditionals.type + actionType);
        }

        if (rules.length === 1 && actionType === "show") {
          let accordionOptionElement = document.querySelector('.accordion-header input[name="' + rules[0].reference + '"][value="' + rules[0].value + '"]');
          if (accordionOptionElement !== null) {
            accordionOptionElement = accordionOptionElement.closest('.accordion-item').querySelector('.accordion-body');
            if (accordionOptionElement !== null) {
              accordionOptionElement.append(element);
              forciblyMoved = true;
            }
          }
        }
      }

      if (!forciblyMoved) {
        target.append(element);
      }

      if (data.caption !== null) {
        const head = document.createElement('h3');
        element.append(head);
        head.classList.add(window.mcb.forms.constants.blocks.classBase + '--title');
        head.append(data.caption);
      }

      const columns = document.createElement('div');
      columns.classList.add(window.mcb.forms.constants.classRoot + 'columns');
      element.append(columns);

      for (let i_c = 0; i_c < data.columns.length; i_c++) {
        const column = document.createElement('div');
        column.classList.add(window.mcb.forms.constants.classRoot + 'column');
        column.classList.add(window.mcb.forms.constants.classRoot + 'column--width--' + data.columns[i_c].width);
        columns.append(column);

        for (let i_f = 0; i_f < data.columns[i_c].fieldRefs.length; i_f++) {
          data.columns[i_c].fieldRefs[i_f].render(column, enrichFieldFunction);
        }
      }

      if (data.condition !== null) {
        formElement.addEventListener('MCB.Events.WebForms.FieldUpdated.Standard', function (e) {
          if (data.conditionTriggers.indexOf(e.detail.origin.alias) >= 0) {
            _logger.trace('evaluateCondition for block', block);
            window.mcb.forms.helpers.evaluateCondition(block, element, data.condition, e.detail.origin, e.detail.value);
          }
        }, false);
      }
    },
    onRendered: function () {
      for (let i_c = data.columns.length - 1; i_c >= 0; i_c--) {
        for (let i_f = data.columns[i_c].fieldRefs.length - 1; i_f >= 0; i_f--) {
          data.columns[i_c].fieldRefs[i_f].onRendered();
        }
      }
    },
  };
};
